import type { DomainManifest } from 'modules/core/lib/manifests/types'

import { useCancelSpaceBooking } from 'modules/space_control/lib/oneHandlers/cancel-space-booking'
import { useCreateSpaceBooking } from 'modules/space_control/lib/oneHandlers/create-space-booking'
import { useUpdateSpaceBooking } from 'modules/space_control/lib/oneHandlers/update-space-booking'

export const manifest = {
  sidebar: () => ({
    items: [],
  }),
  one: {
    createActions: {
      booking: {
        actionResolver: useCreateSpaceBooking,
        policies: [],
        module: 'space_control',
      },
      cancelBooking: {
        actionResolver: useCancelSpaceBooking,
        policies: [],
        module: 'space_control',
      },
      updateBooking: {
        actionResolver: useUpdateSpaceBooking,
        policies: [],
        module: 'space_control',
      },
    },
  },
} as const satisfies DomainManifest
